import { useQuery } from '@tanstack/vue-query'
import { getCryptoWallet } from '../cryptoWalletEndpoints'
import { cryptoWalletKeys } from '../cryptoWalletQueryKeys'

export function useCryptoWalletQuery() {
  return useQuery({
    queryKey: cryptoWalletKeys.wallet(),
    queryFn: getCryptoWallet,
  })
}
